<template>
  <v-container id="maintain" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card color="primary">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">{{ $t("maintain") }}</div>
          </template>

          <v-form ref="form" lazy-validation>
            <v-container class="py-5 mx-0">
              <v-row class="function-block" align="center">
                <v-col>
                  <v-switch v-model="$store.state.withDash">
                    <template v-slot:label>
                      <span class="black--text">
                        {{ $t("enable") }}
                        {{ $t("licensePlate").toLowerCase() }}
                        {{ $t("sign").toLowerCase() }}(-)
                      </span>
                    </template>
                  </v-switch>
                </v-col>
              </v-row>

              <v-row class="function-block" align="center">
                <v-col cols="12" lg="3">
                  <v-row>
                    <v-col>
                      <v-select v-model="list_type" :items="listTypeItems">
                      </v-select>
                    </v-col>

                    <v-col>
                      <v-btn
                        @click="
                          confirmFunction(
                            $t('updateSystemListTypeConfirm'),
                            updateSystemListType
                          )
                        "
                      >
                        {{ $t("update") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" lg="auto">
                  <v-row class="display-2">
                    {{ $t("system") }} {{ $t("list_type").toLowerCase() }}
                  </v-row>

                  <v-row class="Paragraph">
                    {{ $t("systemListTypeHint") }}
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="function-block" align="center">
                <v-col cols="12" lg="3">
                  <v-row>
                    <v-col>
                      <v-select v-model="cool_down" :items="coolDownItems">
                      </v-select>
                    </v-col>

                    <v-col>
                      <v-btn
                        @click="
                          confirmFunction(
                            $t('updateSystemCoolDownConfirm'),
                            updateSystemCoolDown
                          )
                        "
                      >
                        {{ $t("update") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" lg="auto">
                  <v-row class="display-2">
                    {{ $t("system") }} {{ $t("coolDown").toLowerCase() }}
                  </v-row>

                  <v-row class="Paragraph">
                    {{ $t("systemCoolDownHint") }}
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="function-block" align="center">
                <v-col cols="12" lg="3">
                  <v-btn @click="$refs.purgeConfirmDialog.dialog = true">
                    {{ $t("purge") }} {{ $t("system") }}
                  </v-btn>

                  <ConfirmDialog
                    ref="purgeConfirmDialog"
                    :repeatString="'purge'"
                    @doFunction="purgeSystem"
                  ></ConfirmDialog>
                </v-col>

                <v-col cols="12" lg="auto">
                  <v-row class="display-2">
                    {{ $t("purge") }} {{ $t("system").toLowerCase() }}
                  </v-row>

                  <v-row class="Paragraph">
                    {{ $t("purgeSystemHint") }}
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="function-block" align="center">
                <v-col cols="12" lg="3">
                  <v-btn @click="$refs.backupConfirmDialog.dialog = true">
                    {{ $t("backup") }} {{ $t("system") }}
                  </v-btn>

                  <ConfirmDialog
                    ref="backupConfirmDialog"
                    :repeatString="'backup'"
                    @doFunction="backupSystem"
                  ></ConfirmDialog>
                </v-col>

                <v-col cols="12" lg="auto">
                  <v-row class="display-2">
                    {{ $t("backup") }} {{ $t("system").toLowerCase() }}
                  </v-row>

                  <v-row class="Paragraph">
                    {{ $t("backupSystemHint") }}
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="function-block" align="center">
                <v-col cols="12" lg="3">
                  <v-btn @click="$refs.systemRestoreDialog.dialog = true">
                    {{ $t("restore") }} {{ $t("system") }}
                  </v-btn>
                </v-col>

                <SystemRestoreDialog
                  ref="systemRestoreDialog"
                  @restart="restartServer"
                ></SystemRestoreDialog>

                <v-col cols="12" lg="auto">
                  <v-row class="display-2">
                    {{ $t("restore") }} {{ $t("system").toLowerCase() }}
                  </v-row>

                  <v-row class="Paragraph">
                    {{ $t("restoreSystemHint") }}
                  </v-row>
                </v-col>
              </v-row>

              <v-row v-if="false" class="function-block" align="center">
                <v-col cols="12" lg="3">
                  <v-btn
                    @click="
                      confirmFunction(
                        $t('updateStoragePathConfirm'),
                        updateStoragePath
                      )
                    "
                  >
                    {{ $t("update") }} {{ $t("storage") }} {{ $t("path") }}
                  </v-btn>
                </v-col>

                <v-col lg="auto">
                  <v-text-field
                    v-model="storagePath"
                    :label="$t('storage') + ' ' + $t('path')"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" lg="auto">
                  <v-row class="display-2">
                    {{ $t("update") }} {{ $t("storage").toLowerCase() }}
                    {{ $t("path").toLowerCase() }}
                  </v-row>

                  <v-row class="Paragraph">
                    {{ $t("updateStoragePathHint") }}
                  </v-row>
                </v-col>
              </v-row>

              <v-row class="function-block" align="center">
                <v-col cols="12" lg="3">
                  <v-btn @click="$refs.restartConfirmDialog.dialog = true">
                    {{ $t("restart") }} {{ $t("server") }}
                  </v-btn>

                  <ConfirmDialog
                    ref="restartConfirmDialog"
                    :repeatString="'restart'"
                    @doFunction="restartServer"
                  ></ConfirmDialog>
                </v-col>

                <v-col cols="12" lg="auto">
                  <v-row class="display-2">
                    {{ $t("restart") }} {{ $t("server").toLowerCase() }}
                  </v-row>

                  <v-row class="Paragraph">
                    {{ $t("restartServerHint") }}
                  </v-row>
                </v-col>
              </v-row>

              <v-row v-show="false" class="function-block" align="center">
                <v-col cols="12" lg="3">
                  <v-btn @click="pingServer">{{ $t("ping") }}</v-btn>
                </v-col>

                <v-col cols="12" lg="auto">
                  <v-row class="display-2">
                    {{ $t("ping") }} {{ $t("server").toLowerCase() }}
                  </v-row>

                  <v-row class="Paragraph">
                    {{ $t("pingServerHint") }}
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SystemRestoreDialog from "@/components/system/SystemRestoreDialog.vue";
import { getChannels, updateChannel } from "@/endpoint/channel";
import ConfirmDialog from "@/components/base/ConfirmDialog.vue";
import {
  purgeSystem,
  backupSystem,
  restartServer,
  pingServer,
  getCoolDown,
  setCoolDown,
} from "@/endpoint/system";
import { axios } from "@/plugins/axios";
import { confirmFunction } from "@/plugins/util";

export default {
  name: "maintain",
  components: { SystemRestoreDialog, ConfirmDialog },
  data() {
    return {
      checkIntervalId: null,
      port: 8080,
      list_type: null,
      cool_down: null,
      storagePath: "",
      listTypeItems: ["whitelist", "blacklist", "VIP"],
      coolDownItems: ["disabled", 1, 5, 10, 30, 60],
    };
  },
  created() {
    this.init(this);
  },
  watch: {
    "$store.state.withDash"() {
      window.localStorage.setItem("withDash", this.$store.state.withDash);
    },
  },
  methods: {
    confirmFunction: confirmFunction,
    backupSystem: backupSystem,
    pingServer: pingServer,
    async init(scope) {
      scope.getStoragePath();

      let channelTable = await getChannels();
      let channelData = Object.values(channelTable).find(
        (value) => value.inference_camera_uuid == "GLOBAL"
      );
      scope.list_type = channelData["list_type"];

      let coolDown = await getCoolDown();
      if (coolDown.is_enable == true) {
        scope.cool_down = coolDown.cool_down;
      } else {
        scope.cool_down = "disabled";
      }
    },
    getStoragePath() {
      const systemApi = "/system/maintain/storage/path";

      return axios
        .get(systemApi)
        .then((response) => {
          this.storagePath = response.data.path;
        })
        .catch((error) => {
          if (error.response == undefined) {
            this.$store.dispatch("openSnackbar", {
              message: this.$t("systemNetworkError"),
            });
          } else if (error.response.data.status != undefined) {
            this.$store.dispatch("openSnackbar", {
              message: error.response.data.status.message,
            });
          }
        });
    },
    updateSystemListType() {
      let data = {};
      data.list_type = this.list_type;
      updateChannel("GLOBAL", data).then(() => {
        this.$router.go();
      });
    },
    updateSystemCoolDown() {
      let data = {};
      if (this.cool_down == "disabled") {
        data.is_enable = false;
      } else {
        data.is_enable = true;
        data.cool_down = this.cool_down;
      }
      setCoolDown(data).then(() => {
        this.$router.go();
      });
    },
    updateStoragePath() {
      const systemApi = "/system/maintain/storage/path";

      let data = {};
      data.path = this.storagePath;
      this.$store.dispatch("openOverlay");

      return axios
        .post(systemApi, data)
        .then(() => {
          this.$store.dispatch("closeOverlay");
          this.restartServer();
        })
        .catch((error) => {
          this.$store.dispatch("closeOverlay");

          if (error.response == undefined) {
            this.$store.dispatch("openSnackbar", {
              message: this.$t("systemNetworkError"),
            });
          } else if (error.response.data.status != undefined) {
            this.$store.dispatch("openSnackbar", {
              message: error.response.data.status.message,
            });
          }
        });
    },
    purgeSystem() {
      this.$store.dispatch("openOverlay");
      purgeSystem()
        .then(() => {
          this.$store.dispatch("closeOverlay");
          this.restartServer();
        })
        .catch(() => {
          this.$store.dispatch("closeOverlay");
          this.restartServer();
        });
    },
    restartServer() {
      this.$store.dispatch("openOverlay");
      restartServer().then(() => {
        this.setCheckInterval(30);
      });
    },
    checkServer() {
      pingServer()
        .then((response) => {
          window.console.log("success", response);
          this.$store.dispatch("closeOverlay");
          this.clearCheckInterval();
          this.$router.go();
        })
        .catch((error) => {
          window.console.log("error", error);
        });
    },
    setCheckInterval(second) {
      this.checkIntervalId = setInterval(() => {
        this.checkServer();
      }, second * 1000);
    },
    clearCheckInterval() {
      if (this.checkIntervalId != null) {
        clearInterval(this.checkIntervalId);
      }
    },
  },
};
</script>


<style>
.function-block {
  border-style: none;
  border-width: thin;
}
</style>